<script>
import Vue from 'vue'
import WSwitch from '../../Forms/WSwitch/WSwitch.vue'

export default Vue.extend({
    name: 'BoolCellEditor',
    components: {
        WSwitch,
    },
    data () {
        return {
            name: 'select',
            inputValue: false,
            disabled: false,
        }
    },
    created () {
        const { value, name, disabled } = this.params
        this.inputValue = value

        if (name) this.name = name
        if (disabled) this.disabled = disabled
    },
    methods: {
        getValue () {
            return this.inputValue
        },
        isPopup () {
            return true
        },
        handleInput (value) {
            this.inputValue = value
        },
    },
    render (h) {
        return h(
            'div',
            {
                class: 'BoolCellEditor',
            },
            [
                h(WSwitch, {
                    props: {
                        name: this.name,
                        value: !!this.inputValue,
                        placeholder: this.placeholder,
                        disabled: this.disabled,
                    },
                    on: {
                        input: this.handleInput,
                    },
                }),
            ],
        )
    },
})
</script>
